import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/salesOpening/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('salesOpeningLook', record)
        } else {
            record = Session.get('salesOpeningLook') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/afterOpening/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('afterOpeningLook', record)
        } else {
            record = Session.get('afterOpeningLook') || {}
        }
    }
    return record
}

class SalesOpeningLook extends WizContainer {

    componentName = 'SalesOpeningLook'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/salesOpeningDetail',
            payload: {
                key: 'salesOpeningDetail@' + processContentId,
                apiParams: {
                    tutorContentId: processContentId
                }
            }
        })
    }

    render() {
        let { moduleType } = this.state.record
        let { detail } = this.props
        let infoProps = {
            ref: 'info',
            columns: [{
                title: moduleType === 0 ? '销售系统截图' : '售后系统截图',
                name: 'fileId',
                dataIndex: 'fileId',
                formItem: {
                    type: 'custom',
                    render: (r, f) => {
                        let url = r && r.fileId ? getOssFilePath(r.fileId) : ''
                        let fileName = r && r.fileName ? r.fileName : ''
                        return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                    }
                }
            }],
            record: detail.data,
            preview: null,
            footer: null,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={false} >
                <WizCard title={`查看${moduleType === 0 ? '销售' : '售后'}系统开通`}>
                    <WizForm {...infoProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'salesOpeningDetail@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpeningLook)


